export const MORE_LESS_CYCLES = [20, 36];

export const CYCLE_OPTIONS: { value: number; label: string; default?: boolean }[] = [
  { value: 20, label: "Less than 21 days" },
  { value: 21, label: "Around 21 days" },
  { value: 22, label: "Around 22 days" },
  { value: 23, label: "Around 23 days" },
  { value: 24, label: "Around 24 days" },
  { value: 25, label: "Around 25 days" },
  { value: 26, label: "Around 26 days" },
  { value: 27, label: "Around 27 days" },
  { value: 28, label: "Around 28 days", default: true },
  { value: 29, label: "Around 29 days" },
  { value: 30, label: "Around 30 days" },
  { value: 31, label: "Around 31 days" },
  { value: 32, label: "Around 32 days" },
  { value: 33, label: "Around 33 days" },
  { value: 34, label: "Around 34 days" },
  { value: 35, label: "Around 35 days" },
  { value: 36, label: "More than 35 days" },
];
